import { Pipe, PipeTransform } from '@angular/core';
import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';

dayjs.extend(advancedFormat);

@Pipe({
  name: 'dateTime',
  standalone: true,
})
export class DateTimePipe implements PipeTransform {
  transform(value: Date | string | number | undefined | null, format: string = 'Do MMMM h:mma'): string {
    if (!value) {
      return '';
    }
    return dayjs(value).format(format);
  }
}
